import type {KeyTextField, LinkField} from '@prismicio/types';
import {useLinkHelper} from '#imports';
import type {Location} from '@malt/nuxt-common-components-module/types';
import {getSearchURL, getQueryAutocomplete} from '@malt/nuxt-search-module/runtime/composables/useSearchHelpers';
import {useTypeGuards} from './useTypeGuards';

type GetSearchURLParams = {
    baseURLLink: LinkField | KeyTextField;
    query: string;
    location: Location | null;
    sourceComponent?: string; // to track the search_started Amplitude event
};

const {isFilledKeyText, isFilledLink} = useTypeGuards();

export function useSearchHelpers() {
    const {resolvePrismicLink} = useLinkHelper();

    function getSearchUrlFromPrismicLink({baseURLLink, query, location, sourceComponent}: GetSearchURLParams): string {
        if (baseURLLink === null || (!isFilledKeyText(baseURLLink) && !isFilledLink(baseURLLink))) {
            return window.location.href;
        }
        const baseURL = isFilledKeyText(baseURLLink)
            ? baseURLLink
            : baseURLLink.link_type === 'Document'
              ? resolvePrismicLink(baseURLLink)
              : baseURLLink.url;

        return getSearchURL({
            baseURLLink: baseURL,
            query,
            location,
            sourceComponent,
        });
    }

    return {
        getSearchURL: getSearchUrlFromPrismicLink,
        getQueryAutocomplete,
    };
}
